module.exports = __webpack_public_path__ + "img/pin.540acc44.png";